import { Component, OnInit } from '@angular/core';

@Component({
  standalone: false,
  templateUrl: './views/view.html'
})
export class CustomPlaceholderExample implements OnInit {

  itemList = [];
  selectedItems = [];
  settings = {};

  constructor() {

  }
  ngOnInit() {


    this.itemList = [
      { "id": 1, "itemName": "Brazil" },
      { "id": 2, "itemName": "Argentina" },
      { "id": 3, "itemName": "Chile" },
      { "id": 4, "itemName": "Canada" },
      { "id": 5, "itemName": "Colombia" },
      { "id": 6, "itemName": "Brazil" }
    ];

    this.selectedItems = [
      { "id": 1, "itemName": "Brazil" },
      { "id": 2, "itemName": "Argentina" },
      { "id": 3, "itemName": "Chile" },
      { "id": 4, "itemName": "Canada" }];
    this.settings = {
      text: "Select Countries",
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      enableSearchFilter: true,
      classes: "myclass custom-class",
      searchPlaceholderText: "Custom Placeholder text",
      tagToBody: false,
    };
  }
  onItemSelect(item: any) {
    console.log(item);
    console.log(this.selectedItems);
  }
  OnItemDeSelect(item: any) {
    console.log(item);
    console.log(this.selectedItems);
  }
  onSelectAll(items: any) {
    console.log(items);
  }
  onDeSelectAll(items: any) {
    console.log(items);
  }
  cssgist: boolean = false;
  title: string = "Custom search placeholder";
  tsgist: string = "CuppaLabs/48c087b6c0b4381d5bae1c689cc0ee3e";
  htmlgist: string = "CuppaLabs/eb78d42ab7971fda6493586e329bfdb8";
  tstitle: string = "customPlaceholder.ts"
  htmltitle: string = "customPlaceholder.html";
}
